<template>
    <!-- 后台首页 -->
    <div  class="hp">
        <el-container>
            <!-- height="68px" -->
            <el-header>
                <div  class="header-top">
                    <!-- 顶部导航 -->
                    <div class="header-top-logo">
                        <img class="logoImg" src="@/assets/login/logo.png" />
                        <!-- <img class="titleLogo" src="@/assets/login/title.png" /> -->
                         大雄拍机
                    </div>
                    <div class="header-top-nav">

                        <!-- 用户 -->
                        <el-dropdown @command="handleCommand">
                            <div class="user">
                                <el-avatar :src="userInfo.avatar"></el-avatar>
                                <span>{{userInfo.name}}</span>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
                                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </div>
                </div>
            </el-header>
            
            <el-container>
                <el-aside  style="background-color: #fff"  class="menu" @scroll="syncContentScroll">
                    <el-menu 
                    :default-active="activeIndex" 
                    :unique-opened="true" 
                    text-color="#666" >
                        <div v-for="(item,index) in asideList" :key="index" >
                            <el-menu-item :index="item.key" v-if="!item.children && item.isShow == 1"  @click="handleSelect(item)">
                                <img v-if="activeIndex == item.key" class="logo-img" :src="item.imgA" alt="">
                                <img v-else class="logo-img" :src="item.img" alt="">
                                <span  class="ziti" slot="title">{{item.title}}</span>
                            </el-menu-item>
                            <!-- 一级菜单（有子菜单）-->
                            <el-submenu :index="item.key" v-if="item.children && item.isShow == 1">
                                <template slot="title">
                                    <img class="logo-img" :src="item.img" alt="">
                                    <span>{{item.title}}</span>
                                </template>
                                <!-- 遍历二级菜单 -->
                                <div v-for="(i,idx) in item.children" :key="idx">
                                    <!-- 二级菜单（没有三级菜单）-->
                                    <el-menu-item :index="i.key" v-if="!i.children"  @click="handleSelect(i)">{{i.title}}</el-menu-item>
                                    <!-- 二级菜单（有三级菜单）-->
                                    <el-submenu :index="i.key" v-if="i.children">
                                        <template slot="title">{{i.title}}</template>
                                        <el-menu-item 
                                        :index="j.key" 
                                        v-for="(j,jdx) in i.children" 
                                        :key="jdx"
                                        @click="handleSelect(j)"
                                        >{{j.title}}</el-menu-item>
                                    </el-submenu>
                                </div> 
                            </el-submenu>
                        </div>

                    
                    </el-menu>
                </el-aside>
                <el-main  class="content" @scroll="syncContentScroll">
                    <!-- 标签页 -->
                    <!-- <div class="tab">
                        <PathHistory />
                    </div> -->
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>

        <!-- 修改密码 -->
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="form">
                <el-form-item label="密码" :label-width="formLabelWidth">
                    <el-input v-model="form.password" show-password autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth">
                    <el-input v-model="form.password_confirm" show-password autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="savePWD">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
// import PathHistory from '@/components/PathHistory'
import { 
    dxeditPwdUser,
} from "@/api/api";

export default {
    components:{
        // PathHistory
    },
    data() {
        return {
            activeIndex: sessionStorage.getItem('menu') || '1',
            userInfo:JSON.parse(localStorage.getItem('userInfo')) || {},

            asideList:[
                {
                    key:'12',
                    title:'工作台',
                    path:'/index',
                    isShow:0,
                    img:require('@/assets/exhome/gztH.png'),
                    imgA:require('@/assets/exhome/gzt.png'),
                },
                {
                    key:'1',
                    title:'管理员',
                    path:'/admin',
                    isShow:0,
                    img:require('@/assets/exhome/glyH.png'),
                    imgA:require('@/assets/exhome/gly.png'),
                },
                {
                    key:'11',
                    title:'用户管理',
                    path:'/user',
                    isShow:0,
                    img:require('@/assets/exhome/yhglH.png'),
                    imgA:require('@/assets/exhome/yhgl.png'),
                },
                {
                    key:'17',
                    title:'机器人佣金',
                    path:'/robot',
                    isShow:0,
                    img:require('@/assets/exhome/jqrH.png'),
                    imgA:require('@/assets/exhome/jqr.png'),
                },
                {
                    key:'13',
                    title:'进度提示',
                    path:'/progress',
                    isShow:0,
                    img:require('@/assets/exhome/jdtsH.png'),
                    imgA:require('@/assets/exhome/jdts.png'),
                },
                {
                    key:'9',
                    title:'质检库',
                    path:'/qualityInspection',
                    isShow:0,
                    img:require('@/assets/exhome/zjH.png'),
                    imgA:require('@/assets/exhome/zj.png'),
                },
                {
                    key:'10',
                    title:'核价库',
                    path:'/priceVerification', 
                    isShow:0,
                    img:require('@/assets/exhome/hjH.png'),
                    imgA:require('@/assets/exhome/hj.png'),
                },
                {
                    key:'8',
                    title:'待拍库',
                    path:'/auctionPhone',
                    isShow:0,
                    img:require('@/assets/exhome/dpkH.png'),
                    imgA:require('@/assets/exhome/dpk.png'),
                },
                {
                    key:'7',
                    title:'任务库',
                    path:'',
                    isShow:0,
                    img:require('@/assets/exhome/rwkH.png'),
                    imgA:require('@/assets/exhome/rwk.png'),
                    children: [
                        {
                            key:'7-1',
                            path: '/task',
                            title: '任务库',
                        },{
                            key:'7-2',
                            path: '/pendingOrder',
                            title: '待确认订单',
                        },{
                            key:'7-3',
                            path: '/refundFailed',
                            title: '退款异常',
                        },
                    ]
                },
                {
                    key:'15',
                    title:'裂变管理',
                    path:'/fission',
                    isShow:0,
                    img:require('@/assets/exhome/lbglH.png'),
                    imgA:require('@/assets/exhome/lbgl.png'),
                },
                {
                    key:'2',
                    title:'系统设置',
                    path:'',
                    isShow:0,
                    img:require('@/assets/exhome/xtszH.png'),
                    imgA:require('@/assets/exhome/xtsz.png'),
                    children: [
                        {
                            key:'2-1',
                            path: '/deposit',
                            title: '交易保证金',
                        },{
                            key:'2-2',
                            path: '/commission',
                            title: '佣金设置',
                        },
                        // {
                        //     key:'2-3',
                        //     path: '/proxyBidding',
                        //     title: '保底待拍',
                        // },
                    ]
                },
                {
                    key:'16',
                    title:'首页设置',
                    path:'',
                    isShow:0,
                    img:require('@/assets/exhome/syszH.png'),
                    imgA:require('@/assets/exhome/sysz.png'),
                    children: [
                        {
                            key:'16-1',
                            path: '/taskReminder',
                            title: '任务提醒',
                        },{
                            key:'16-2',
                            path: '/announcementNotice',
                            title: '公告提示',
                        },{
                            key:'16-3',
                            path: '/banner',
                            title: 'banner图片',
                        },
                    ]
                },
                {
                    key:'14',
                    title:'保底待拍',
                    path:'/proxyBidding',
                    isShow:0,
                    img:require('@/assets/exhome/bddpH.png'),
                    imgA:require('@/assets/exhome/bddp.png'),
                },
                {
                    key:'3',
                    title:'机型档案',
                    path:'',
                    isShow:0,
                    img:require('@/assets/exhome/jxdaH.png'),
                    imgA:require('@/assets/exhome/jxda.png'),
                    children: [
                        {
                            key:'3-1',
                            path: '/phoneSeries',
                            title: '手机系列',
                        },
                        {
                            key:'3-2',
                            path: '/phoneModel',
                            title: '手机机型',
                        },
                        {
                            key:'3-3',
                            path: '/phoneColor',
                            title: '手机颜色',
                        }
                    ]
                },
                {
                    key:'4',
                    title:'基本信息',
                    path:'',
                    isShow:0,
                    img:require('@/assets/exhome/jbxxH.png'),
                    imgA:require('@/assets/exhome/jbxx.png'),
                    children: [
                        {
                            key:'4-1',
                            path: '/storageCapacity',
                            title: '存储容量',
                        },
                        {
                            key:'4-2',
                            path: '/warrantyPeriod',
                            title: '保修期时长',
                        },
                        {
                            key:'4-3',
                            path: '/channel',
                            title: '渠道',
                        },
                        {
                            key:'4-4',
                            path: '/battery',
                            title: '电池',
                        },
                        // {
                        //     key:'4-5',
                        //     path: '/chargeCycles',
                        //     title: '充电次数',
                        // }
                    ]
                },
                {
                    key:'5',
                    title:'检修情况',
                    path:'',
                    isShow:0,
                    img:require('@/assets/exhome/jxqkH.png'),
                    imgA:require('@/assets/exhome/jxqk.png'),
                    children: [
                        {
                            key:'5-1',
                            title: '外观成色',
                            children:[
                                {
                                    key:'5-1-1',
                                    path: '/fuselage',
                                    title: '机身',
                                },{
                                    key:'5-1-2',
                                    path: '/screenAppearance',
                                    title: '屏幕外观',
                                },{
                                    key:'5-1-3',
                                    path: '/screenDisplay',
                                    title: '屏幕显示',
                                },{
                                    key:'5-1-4',
                                    path: '/borderBackplate',
                                    title: '边框背板',
                                }
                            ]
                        },
                        {
                            key:'5-2',
                            title: '拆修情况',
                            children:[
                                {
                                    key:'5-2-1',
                                    path: '/frontCamera',
                                    title: '前摄像头',
                                },{
                                    key:'5-2-2',
                                    path: '/rearCamera',
                                    title: '后摄像头',
                                },{
                                    key:'5-2-3',
                                    path: '/rearCase',
                                    title: '后壳',
                                },{
                                    key:'5-2-4',
                                    path: '/powerBank',
                                    title: '电池',
                                },{
                                    key:'5-2-5',
                                    path: '/functionalParts',
                                    title: '功能零件',
                                },{
                                    key:'5-2-6',
                                    path: '/screen',
                                    title: '屏幕',
                                },{
                                    key:'5-2-7',
                                    path: '/motherboard',
                                    title: '主板',
                                }
                            ]
                        },
                        {
                            key:'5-3',
                            title: '使用功能',
                            children:[
                                {
                                    key:'5-3-1',
                                    path: '/afterSales',
                                    title: '售后维修',  // 售后维修案例
                                },{
                                    key:'5-3-2',
                                    path: '/powerOn',
                                    title: '开机情况',  // 开机情况等
                                },{
                                    key:'5-3-3',
                                    path: '/restoreFactorySettings',
                                    title: '恢复出厂设置',  // 是否可恢复出厂设置
                                },{
                                    key:'5-3-4',
                                    path: '/frontFacingCamera',
                                    title: '前摄拍照摄像',
                                },{
                                    key:'5-3-5',
                                    path: '/rearCameraPhotography',
                                    title: '后摄拍照摄像',
                                },{
                                    key:'5-3-6',
                                    path: '/call',
                                    title: '通话功能',
                                },{
                                    key:'5-3-7',
                                    path: '/sound',
                                    title: '声音功能',
                                },{
                                    key:'5-3-8',
                                    path: '/confirmLogout',
                                    title: 'icloud',  // icloud是否注销
                                },{
                                    key:'5-3-9',
                                    path: '/charging',
                                    title: '充电功能',
                                },{
                                    key:'5-3-10',
                                    path: '/wireless',
                                    title: '无线功能',
                                },{
                                    key:'5-3-11',
                                    path: '/compass',
                                    title: '指南针功能',
                                },{
                                    key:'5-3-12',
                                    path: '/touch',
                                    title: '触摸功能',
                                },{
                                    key:'5-3-13',
                                    path: '/faceRecognition',
                                    title: '面容识别功能',
                                },{
                                    key:'5-3-14',
                                    path: '/screenSensor',
                                    title: '屏幕传感器', // 屏幕传感器功能
                                },{
                                    key:'5-3-15',
                                    path: '/vibration',
                                    title: '震动功能',
                                },{
                                    key:'5-3-16',
                                    path: '/dataConnection',
                                    title: '数据连接', // 数据连接功能
                                },{
                                    key:'5-3-17',
                                    path: '/sideButton',
                                    title: '侧键',
                                }
                            ]
                        }
                    ]
                },
                {
                    key:'6',
                    title:'等级设置',
                    isShow:0,
                    path:'/levelSelection',
                    img:require('@/assets/exhome/djxzH.png'),
                    imgA:require('@/assets/exhome/djxz.png'),
                },
            ],

            form:{
                password:'',
                password_confirm:'',
            },
            dialogFormVisible :false,
            formLabelWidth: '84px',

            // 角色列表
            // 管理账号角色权限:(其中账户设置权限时可多角色选择)
            // 1、管理员:全部功能权限，包括:账号添加，修改，停用，删除，密码重置，权限设置
            // 2、质检员:质检库操作
            // 3、核价员:核价库操作
            // 4、复检员:待拍库操作
            // 5、商务客服:任务库操作
            // 6、商务专员:质检库，核价库，待拍库，任务库
            xtglyRole:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
            glyRole:[1,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
            zjyRole:[9,12,13,15],
            hjyRole:[10,12,13,15],
            fjyRole:[8,12,13,15],
            swkfRole:[7,12,13,15],
            swzyRole:[9,10,8,7,12,13,14,15],
        }
    },
    methods: {
        handleSelect(e) {
            this.activeIndex = e.key
            if( this.$route.path != e.path && e.path!=''){
                this.$router.push(e.path)
            }
            
            if(e.path == '/qualityInspection' || e.path == '/priceVerification'){
                sessionStorage.removeItem('canshu')
            }

            this.activeIndex = e.key
            sessionStorage.setItem('menu',e.key)
        },
        syncMenuScroll(event) {
            const content = this.$el.querySelector('.content');
            content.scrollTop = event.target.scrollTop;
        },
        syncContentScroll(event) {
            const menu = this.$el.querySelector('.menu');
            menu.scrollTop = event.target.scrollTop;
        },
        handleCommand(command) {
            if(command=='logOut'){
                this.LogOut()
            }else if(command=='changePwd'){
                this.changePwd()
            }
        },
        changePwd(){
            this.form = {
                password:'',
                password_confirm:'',
            }
            this.dialogFormVisible = true
        },
        async savePWD(){
            try {
                const res = await dxeditPwdUser(this.form)

                if(res.code==1){
                    this.$message.success('密码修改成功')
                    this.dialogFormVisible = false
                }else{
                    this.$message.error('密码修改失败，'+res.msg)
                }
            } catch (error) {
                console.log(error,'error');
            }
        },
        // 退出登录
        LogOut(){
            localStorage.removeItem("userInfo");
            localStorage.removeItem("isLogin");
            localStorage.removeItem("token");
            sessionStorage.removeItem('menu')


            this.$message({
                type:'success',
                message:'退出登录成功'
            })
            this.$router.push('/login')
        },
        getQuanxian(){
            let userRole = JSON.parse(localStorage.getItem('userInfo')).role_id
            let root = JSON.parse(localStorage.getItem('userInfo')).root
            let arr = []

            if(root==1){ // '系统管理员'
                arr = this.xtglyRole
            }else if(userRole==1){ // '管理员'
                arr = this.glyRole
            }else if(userRole==2){ // '质检员'
                arr = this.zjyRole
            }else if(userRole==3){ // '核价员'
                arr = this.hjyRole
            }else if(userRole==4){ // '复检员'
                arr = this.fjyRole
            }else if(userRole==5){ // '商务客服'
                arr = this.swkfRole
            }else if(userRole==6){ // '商务专员'
                arr = this.swzyRole
            }

            for (let i = 0; i < this.asideList.length; i++) {
                let key = Number(this.asideList[i].key)
                if(arr.includes(key)){
                    this.asideList[i].isShow = 1
                }
            }

            for (let i = 0; i < this.asideList.length; i++) {
                if(this.asideList[i].isShow == 1){
                    // 首次进来
                    if(sessionStorage.getItem('menuUrl') == 1){
                        this.activeIndex = this.asideList[i].key
                        this.$router.push(this.asideList[i].path)
                        sessionStorage.setItem('menuUrl',2)
                    }
                    return
                }
            }
        }
    },
    mounted() {
        

        this.getQuanxian()
        // 页面刷新时重置历史记录
        // this.$store.commit('RESET_HISTORY', {
        //     path: this.$route.fullPath,
        //     name: this.$route.name || '当前页面',
        // })
    },
    beforeDestroy() {

    },
}
</script>
    
<style style lang="scss" scoped>
.el-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0;
    z-index: 999;
}

.el-aside{
    height: 92vh;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    font-size: 16px;
    color: #666666;
    padding-top: 68px;

    width: 238px !important;
    box-sizing: content-box;
    color: #999999;
}


.logo-img{
    width: 20px;
    height: 20px;
    margin-right: 16px;
}
.el-menu{
    border: 0;
    // height: 700px;

    .el-menu-item{
        // margin-bottom: 10px;
        height: 68px;
        width: 220px;
        line-height: 68px;
        font-size: 16px;
    }
}

:deep(.el-menu){
    .el-submenu__title{
        // margin-bottom: 10px;
        height: 68px;
        width: 220px;
        line-height: 68px;
        font-size: 16px;
    }

    .el-menu-item-group__title{
        padding: 0px;
    }
}

.el-menu-item.is-active {
    width: 220px;
    height: 68px;
    background: #F2F6FF;
    color: #0277FD;
    border-right: 4px solid #0277FD;
}

.ziti{
    font-size: 16px !important;
    position: relative;
    .dian{
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 5px;
        background: #FE3300;
        // margin-left: 10px;
        position: absolute;
        top: -5px;
        right: -15px;
    }
}

.el-submenu__title{
    font-size: 16px !important;
}

// .menu {
//     width: 258px !important;
// }

.menu, .content {
  overflow-y: auto;
//   height: 800px; /* 根据需要调整高度 */
}

.tab{
    height: 48px;
    background: #FFFFFF;
}

.content{
    height: 90vh;
    margin: 68px 0px 24px;
    padding: 0px;
}

:deep(.el-badge){
    .el-badge__content.is-fixed{
        top: 14px;
        right: 0px
    }
}

.header-top {
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 80px;
    border-bottom: 1px solid #eeeeee;
    z-index: 9999;
    background: #FFFFFF;
    .header-top-logo {
        padding: 25px 0;
        display: flex;
        align-items: center;
        .logoImg{
            width: 42px;
            height: 42px;
        }

        .titleLogo{
            width: 266px;
            height: 24px;
            margin-left: 8px;
        }
    }

  .header-top-nav {
      display: flex;

      .kaitong{
          width: 100px;
          height: 38px;
          background: #EDF6FF;
          border-radius: 8px 8px 8px 8px;
          border: 0;
          font-size: 16px;
          color: #0073F5;

          margin-right: 18px;
      }
      .user{
        display: flex;
        align-items: center;
      .el-avatar{
          width: 36px;
          height: 36px;
          margin-right: 8px;
      }
      span{
          font-size: 16px;
          color: #666666;
      }
    }
  }
}

.kaifa{
    width: 100%;
    margin-top: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.shoucang{
  background: rgba(6,79,175,0.16);
  padding: 10PX 14PX;
  color: #fff;
  display: flex;
  color: #064FAF;
  margin-left: 12PX;
  margin-right: 12PX;
}
</style>